(() => {
  "use strict";

  const FRAME_VISUALS = {
    stock: {
      Black: {
        image: "https://cdn.shopify.com/s/files/1/0604/3244/9629/files/905print-stock-frame-black-corner-thumb.jpg?v=1785632590",
        frame: "#080808",
        side: "#0d0c0c",
        surface: "linear-gradient(135deg, rgba(255,255,255,.08), rgba(0,0,0,.18))",
      },
      White: {
        image: "https://cdn.shopify.com/s/files/1/0604/3244/9629/files/905print-stock-frame-white-corner-thumb.jpg?v=1785632603",
        frame: "#f6f5f0",
        side: "#ddd9d1",
        surface: "linear-gradient(135deg, rgba(255,255,255,.72), rgba(155,150,140,.13))",
      },
      Oak: {
        image: "https://cdn.shopify.com/s/files/1/0604/3244/9629/files/905print-stock-frame-oak-corner-thumb.jpg?v=1785632612",
        frame: "#bd8751",
        side: "#a77b51",
        surface: "linear-gradient(135deg, rgba(255,232,190,.20), rgba(88,52,24,.16))",
      },
    },
    floater: {
      Black: {
        image: "https://cdn.shopify.com/s/files/1/0604/3244/9629/files/905print-floater-frame-black-corner-thumb.jpg?v=1785632619",
        frame: "#070707",
        side: "#070707",
        surface: "linear-gradient(135deg, rgba(255,255,255,.08), rgba(0,0,0,.20))",
      },
      White: {
        image: "https://cdn.shopify.com/s/files/1/0604/3244/9629/files/905print-floater-frame-white-corner-thumb.jpg?v=1785632641",
        frame: "#f4f2ed",
        side: "#d7d3ca",
        surface: "linear-gradient(135deg, rgba(255,255,255,.78), rgba(150,145,136,.13))",
      },
      Oak: {
        image: "https://cdn.shopify.com/s/files/1/0604/3244/9629/files/905print-floater-frame-oak-corner-thumb.jpg?v=1785632630",
        frame: "#b77f48",
        side: "#855b38",
        surface: "linear-gradient(135deg, rgba(255,226,178,.18), rgba(80,45,20,.14))",
      },
      Gold: {
        image: "https://cdn.shopify.com/s/files/1/0604/3244/9629/files/905print-floater-frame-gold-corner-thumb.jpg?v=1785632649",
        frame: "#c79a42",
        side: "#8b6724",
        surface: "linear-gradient(135deg, rgba(255,232,160,.28), rgba(95,62,18,.18))",
      },
    },
  };

  function escapeHtml(value) {
    return String(value || "").replace(/[&<>"']/g, (character) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
    })[character]);
  }

  function injectStyles() {
    if (document.getElementById("print-studio-frame-visuals-style")) return;
    const style = document.createElement("style");
    style.id = "print-studio-frame-visuals-style";
    style.textContent = `
      .print-studio__swatch--image {
        min-height: 154px;
        grid-template-rows: auto auto;
        gap: 9px;
        padding: 10px;
        align-items: stretch;
        text-align: center;
      }
      .print-studio__frame-thumb {
        display: block;
        width: 100%;
        aspect-ratio: 1 / .72;
        overflow: hidden;
        border: 1px solid rgba(32,34,41,.14);
        background: #f7f6f3;
      }
      .print-studio__frame-thumb img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .print-studio__frame-thumb--stock img {
        object-position: 78% 78%;
      }
      .print-studio__frame-thumb--floater img {
        object-position: 64% 72%;
      }
      .print-studio__swatch--image strong {
        align-self: center;
        font-weight: 900;
      }
      .print-studio__frame.has-frame-visual {
        background-color: var(--frame);
        background-image: var(--frame-surface);
        background-blend-mode: normal;
      }
      .print-studio__frame.has-frame-visual[data-frame-style="White"] {
        outline: 1px solid rgba(32,34,41,.12);
      }
    `;
    document.head.append(style);
  }

  function patchStudio(Studio) {
    const proto = Studio && Studio.prototype;
    if (!proto || proto.__frameVisualsPatched) return;

    proto.__frameVisualsPatched = true;

    const originalFrameColours = proto.frameColours;
    const originalFrameModes = proto.frameModes;
    const originalRenderFrameColours = proto.renderFrameColours;
    const originalUpdatePreview = proto.updatePreview;

    proto.frameVisualSet = function () {
      if (this.isStockFramePaper && this.isStockFramePaper()) return FRAME_VISUALS.stock;
      if (this.material && this.material.type === "canvas" && this.frameMode === "floater") return FRAME_VISUALS.floater;
      return null;
    };

    proto.frameColours = function () {
      const set = this.frameVisualSet ? this.frameVisualSet() : null;
      if (set) return Object.keys(set);
      return originalFrameColours ? originalFrameColours.call(this) : [];
    };

    proto.frameModes = function () {
      const modes = originalFrameModes ? originalFrameModes.call(this) : [];
      return modes.map((mode) => {
        if (mode && mode.key === "floater") return { ...mode, note: "Black, white, oak, or gold floater frame" };
        return mode;
      });
    };

    proto.renderFrameColours = function () {
      const el = this.querySelector("[data-frame-colours]");
      if (!el) {
        if (originalRenderFrameColours) originalRenderFrameColours.call(this);
        return;
      }

      const set = this.frameVisualSet ? this.frameVisualSet() : null;
      if (!set) {
        if (originalRenderFrameColours) originalRenderFrameColours.call(this);
        return;
      }

      el.innerHTML = "";
      const colours = this.frameColours();
      if (!colours.includes(this.frameColour)) this.frameColour = colours[0] || "Black";

      colours.forEach((name) => {
        const visual = set[name];
        const label = document.createElement("label");
        label.className = "print-studio__swatch print-studio__swatch--image" + (name === this.frameColour ? " is-picked" : "");
        label.innerHTML = `
          <input type="radio" name="studio_frame_colour">
          <span class="print-studio__frame-thumb print-studio__frame-thumb--${set === FRAME_VISUALS.stock ? "stock" : "floater"}">
            <img src="${visual.image}" alt="${escapeHtml(name)} frame corner" loading="lazy">
          </span>
          <strong>${escapeHtml(name)}</strong>
        `;
        label.addEventListener("click", () => {
          this.frameColour = name;
          this.pick(el, label);
          if (typeof this.renderSizes === "function") this.renderSizes();
          if (typeof this.sync === "function") this.sync();
        });
        el.append(label);
      });
    };

    proto.updatePreview = function () {
      if (originalUpdatePreview) originalUpdatePreview.call(this);

      const frame = this.querySelector("[data-frame]");
      const set = this.frameVisualSet ? this.frameVisualSet() : null;
      const visual = set && set[this.frameColour];
      if (!frame || !visual) {
        if (frame) {
          frame.classList.remove("has-frame-visual");
          frame.removeAttribute("data-frame-style");
        }
        return;
      }

      frame.classList.add("has-frame-visual");
      frame.dataset.frameStyle = this.frameColour;
      this.style.setProperty("--frame", visual.frame);
      this.style.setProperty("--frame-side", visual.side);
      this.style.setProperty("--frame-surface", visual.surface);
    };
  }

  function init() {
    injectStyles();
    const Studio = customElements.get("print-frame-studio");
    patchStudio(Studio);
    document.querySelectorAll("print-frame-studio").forEach((studio) => {
      if (typeof studio.renderFinishOptions === "function") studio.renderFinishOptions();
      if (typeof studio.sync === "function") studio.sync();
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", injectStyles);
  else injectStyles();

  if (window.customElements && window.customElements.whenDefined) window.customElements.whenDefined("print-frame-studio").then(init);
})();
